import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit } from '@angular/core';
import { CoursesService } from '@draeger-academy/common';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { MyCourseItem } from 'models/myCourse';
import { BehaviorSubject, Observable } from 'rxjs';
@Component({
    selector: 'da-info-package',
    templateUrl: './info-package.component.html',
    styleUrls: ['./info-package.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoPackageComponent implements OnInit {
    @Input() course: MyCourseItem;
    @Input() status: any;
    @Input() testResults: any;
    @Input() mycourses: MyCourseItem[];
    public allCoursesFinished = false;
    public allSubCoursesFinished = false;
    public allUserCourses: any;
    public longModuleTitle = false;
    private _$subModuleArray: BehaviorSubject<MyCourseItem[]> = new BehaviorSubject<MyCourseItem[]>(null);

    constructor(public config: ConfigurationService, private _courseService: CoursesService) {}

    public get subModuleArray$(): Observable<MyCourseItem[]> {
        return this._$subModuleArray.asObservable();
    }

    @HostListener('document:visibilitychange', ['$event'])
    visibilitychange() {
        this.checkHiddenDocument();
    }

    checkHiddenDocument() {
        if (document.visibilityState === 'visible') {
            this.getUserCourses();
        }
    }

    ngOnInit() {
        this.allUserCourses = this.mycourses;
        this.getsubModuleArray();
    }

    getUserCourses() {
        this._$subModuleArray.next(null);
        this._courseService.getUserCourses().then((data) => {
            if (data) {
                this.allUserCourses = data;
                this.getsubModuleArray();
            }
        });
    }

    private getsubModuleArray() {
        const unOrderedsubModulArray = [];
        const subModuleArray = [];
        for (const i of this.allUserCourses) {
            if (this.course.infoPackageAvailable && this.course.infoPackageSubModuleIds.length > 0) {
                if (this.course.infoPackageSubModuleIds.indexOf(i.id) !== -1) {
                    if (unOrderedsubModulArray.length === 0) {
                        unOrderedsubModulArray.push(i);
                    } else {
                        const onlyIdArrayOfSubmodules = unOrderedsubModulArray.map((course) => course.id);
                        if (onlyIdArrayOfSubmodules.indexOf(i.id) === -1) {
                            unOrderedsubModulArray.push(i);
                        }
                    }
                }
            }
        }
        for (const i of this.course.infoPackageSubModuleIds) {
            for (const j of unOrderedsubModulArray) {
                if (i === j.id) {
                    subModuleArray.push(j);
                }
            }
        }
        this.checkIfAllSubCoursesAreFinished(subModuleArray);

        for (const i of this.allUserCourses) {
            if (i.id === this.course.id) {
                subModuleArray.push(i);
                break;
            }
        }
        this._$subModuleArray.next(subModuleArray);
        this.checkIfAllCoursesAreFinished(this._$subModuleArray.getValue());
    }

    private checkIfAllCoursesAreFinished(courseArray) {
        const arrayOfNotFinishedCourses = [];
        for (const i of courseArray) {
            if (i.testResult !== 'PASSED') {
                arrayOfNotFinishedCourses.push(i);
            }
        }
        if (arrayOfNotFinishedCourses.length === 0) {
            this.allCoursesFinished = true;
        } else {
            this.allCoursesFinished = false;
        }
        this._checkLongTitles();
    }

    private checkIfAllSubCoursesAreFinished(subModuleArray) {
        const arrayOfNotFinishedSubCourses = [];
        for (const i of subModuleArray) {
            if (i.testResult !== 'PASSED') {
                arrayOfNotFinishedSubCourses.push(i);
            }
        }
        if (arrayOfNotFinishedSubCourses.length === 0) {
            this.allSubCoursesFinished = true;
        } else {
            this.allSubCoursesFinished = false;
        }
    }

    public _checkLongTitles() {
        for (const i of this._$subModuleArray.getValue()) {
            if (i.title.length > 80) {
                this.longModuleTitle = true;
            }
        }
    }
    public downloadCertificate() {
        window.location.href = this.course.certificateUrl;
    }
}
